import * as Types from './actionTypes';

export const approveProfile = (id) => ({
  type: Types.APPROVE_PROFILE,
  payload: {
    id,
  },
});
export const suspendProfile = (id) => ({
  type: Types.SUSPEND_PROFILE,
  payload: {
    id,
  },
});

export const revokeProfileDone = (id, role) => ({
  type: Types.REVOKE_PROFILE_DONE,
  payload: {
    id,
    role,
  },
});

export const profileActivated = (id, type) => ({
  type: Types.PROFILE_ACTIVATED,
  payload: {
    id,
    type,
  },
});

export const profileSuspended = (id, type) => ({
  type: Types.PROFILE_SUSPENDED,
  payload: {
    id,
    type,
  },
});

export const toggleProfileStatus = (id, type, status) => ({
  type: Types.TOGGLE_PROFILE_STATUS,
  payload: {
    id,
    type,
    status,
  },
});

export const keepProfileStatus = () => ({
  type: Types.KEEP_PROFILE_STATUS,
});

export const makeProfile = (id, role) => ({
  type: Types.MAKE_PROFILE,
  payload: {
    id,
    role,
  },
});

export const makeProfileDone = (id, role, grantedProfileId) => ({
  type: Types.MAKE_PROFILE_DONE,
  payload: {
    id,
    role,
    grantedProfileId,
  },
});

export const makingProfile = () => ({
  type: Types.MAKING_PROFILE,
  payload: {},
});
export const toggleMakingProfile = () => ({
  type: Types.TOGGLE_MAKING_PROFILE,
  payload: {},
});
export const madeProfile = () => ({
  type: Types.MADE_PROFILE,
  payload: {},
});
